export default __webpack_public_path__ + "static/media/copy.327e7999.svg";